export class  Vehicle {
  vehicleId: string;
  routeId: string;
  provider: string;
  lat: number;
  lon: number;
  routeDirection: string;
  finalStop: string;
  heading: number;
  time: number;
  blockId: string;
  data: string;

  constructor() {
  }

  deserialize(input: any) {
    (<any>Object).assign(this, input);
    return this;
  }
}
